import { Reducer } from "redux";

import {
    SELL_EXPERIENCE_POPUP_CLOSE,
    SELL_EXPERIENCE_POPUP_SHOW,
    SELL_EXPERIENCE_POPUP_WRITE,
    SellExperiencePopupCloseAction,
    SellExperiencePopupShowAction,
    SellExperiencePopupWriteAction,
} from "@/mk2/apps/bazaar/containers/SellExperiencePopup/SellExperiencePopup.actions";

export interface State {
    show: boolean;
    productId: number;
    title: string;
}

export const initialState: State = {
    show: false,
    productId: null,
    title: "",
};

type Actions =
    | SellExperiencePopupShowAction
    | SellExperiencePopupWriteAction
    | SellExperiencePopupCloseAction;

const reducer: Reducer<State, Actions> = (state = initialState, action) => {
    switch (action.type) {
        case SELL_EXPERIENCE_POPUP_SHOW:
            return {
                ...state,
                show: true,
                productId: action.productId,
                title: action.title,
            };
        case SELL_EXPERIENCE_POPUP_WRITE:
        case SELL_EXPERIENCE_POPUP_CLOSE:
            // Close modal
            return {
                ...state,
                show: false,
                productId: null,
                title: "",
            };
        default:
            return state;
    }
};

export default reducer;
